import handleClick from './handleClick';
import Button from 'components/Button';
import React from 'react';

const getButtons = (
    { closeModal, disableFooterButton, disableCloseButton, props, history, dispatch, handleNext, buttons }) => {
    const defaultCloseButton = (
        <Button onClick={closeModal}>
            Voltar
        </Button>
    );

    if (disableFooterButton) {
        return null;
    }
    if (!buttons?.length && !disableCloseButton) {
        return defaultCloseButton;
    }

    return buttons?.map(({ action, label, onClick = action, redirect, ...buttonProps }, index) => (
        <Button
            key={index}
            {...buttonProps}
            onClick={(event) => handleClick({ closeModal, props, event }, { onClick, redirect, history, dispatch, handleNext })}
        >
            {label}
        </Button>
    ));
};

export default getButtons;